import React from 'react';
import * as Io5 from 'react-icons/io5';

/** Same as Expo `filledIconName`: solid Ionicons (drops `-outline` suffix). */
export function filledIconName(outlineName) {
  if (typeof outlineName !== 'string') return outlineName;
  return outlineName.endsWith('-outline') ? outlineName.slice(0, -8) : outlineName;
}

function kebabToPascal(kebab) {
  return kebab.split('-').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join('');
}

function resolveComponentKey(name, useFilledGlyph) {
  const n = typeof name === 'string' ? name : 'ellipse-outline';
  const segment = useFilledGlyph ? filledIconName(n) : n;
  return `Io${kebabToPascal(segment)}`;
}

const Fallback = Io5.IoEllipse;

/**
 * Renders Ionicons 5 via `react-icons/io5`, matching `@expo/vector-icons` Ionicons names.
 * @param {string} name - e.g. `home-outline`, `document-text-outline`, or already-solid `flash`
 * @param {boolean} filled - if true, map `*-outline` → filled (IoHome); if false, keep outline (IoHomeOutline)
 */
export function NeoIonicons({ name, size = 24, color, filled: useFilledGlyph = true, style, className, title }) {
  const key = resolveComponentKey(name, useFilledGlyph);
  const Icon = Io5[key];
  if (!Icon) {
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('[NeoIonicons] missing', key, 'for', name);
    }
    return <Fallback size={size} color={color} style={style} className={className} title={title} />;
  }
  return (
    <Icon
      size={size}
      color={color}
      style={{ flexShrink: 0, display: 'block', ...style }}
      className={className}
      title={title}
    />
  );
}
